import { apiClient } from './apiClient';

import type { ActiveJobPostingsQuery, ActiveJobPostingsResponse } from '@/types/jobPosting.types';

export const jobPostingApi = {
  /**
   * List active job postings (public, no auth required).
   * Supports search, filters, sorting, and pagination via query params.
   */
  listActive: (query?: ActiveJobPostingsQuery) => {
    const params = new URLSearchParams();

    if (query?.q) params.set('q', query.q);
    if (query?.role) params.set('role', query.role);
    if (query?.siteState) params.set('siteState', query.siteState);
    if (query?.siteCity) params.set('siteCity', query.siteCity);
    if (query?.from) params.set('from', query.from);
    if (query?.to) params.set('to', query.to);
    if (query?.sortBy) params.set('sortBy', query.sortBy);
    if (query?.sortOrder) params.set('sortOrder', query.sortOrder);
    if (query?.page) params.set('page', query.page.toString());
    if (query?.limit) params.set('limit', query.limit.toString());

    const qs = params.toString();
    const url = qs ? `/job-postings/active?${qs}` : '/job-postings/active';

    return apiClient.get<ActiveJobPostingsResponse>(url);
  },

  /**
   * Get a single active job posting by ID.
   * Walks paginated active postings until the matching item is found.
   */
  getActiveById: async (id: string) => {
    let page = 1;
    const limit = 50;

    while (true) {
      const response = await jobPostingApi.listActive({ limit, page });
      const posting = response.data.items.find((item) => item.jobPostingId === id);

      if (posting) {
        return posting;
      }

      if (page >= response.data.meta.totalPages) {
        return null;
      }

      page += 1;
    }
  },
};
